import React, { useState } from 'react';

import { ReactComponent as IconDropdownArrow } from 'src/assets/icons/icon-dropdown-arrow.svg';

import './dropdown.scss';

export interface IField {
  icon?: JSX.Element;
  key: string | null;
  value: string;
}

interface IPropsDropdownAnimation {
  wrapperClass?: string;
  label?: string;
  selectedValue?: string | null;
  options: IField[];
  customValue?: string | null;
  customOption?: JSX.Element;
  disabledOptions?: (IField | undefined)[];
  disabled?: boolean;
  placeholder?: string;
  onChange: (newValue: IField) => void;
}

const Dropdown: React.FC<IPropsDropdownAnimation> = ({
  wrapperClass = '',
  label,
  selectedValue,
  options,
  customValue,
  customOption,
  disabledOptions = [],
  disabled = false,
  placeholder,
  onChange,
}): JSX.Element => {
  const [isOpen, setOpen] = useState(false);

  const onToggle = () => {
    setOpen(!isOpen);
  };

  const findSelectedValue = options.find(({ key }: IField) => key === selectedValue);

  const onSelect = (option: IField, isDisabled: boolean) => {
    if (!isDisabled) onChange(option);
  };

  return (
    <div className={`dropdown ${wrapperClass}`}>
      {label && <p className="dropdown-label">{label}</p>}

      <div className={`dropdown-wrapper ${isOpen ? `dropdown-wrapper-active` : ''}`}>
        <button
          className={`dropdown-button ${isOpen ? `dropdown-button-active ` : ''} ${
            findSelectedValue || customValue ? 'value' : 'placeholder'
          }`}
          onClick={() => (disabled ? {} : onToggle())}
          disabled={disabled}
          type="button"
        >
          {findSelectedValue?.icon && findSelectedValue.icon}
          {findSelectedValue ? findSelectedValue.value : customValue || placeholder}

          <IconDropdownArrow className="icon-dropdown-arrow" />
        </button>

        <div className={`dropdown-content  ${isOpen ? `dropdown-content-active ` : ''}`}>
          <ul className="list-content">
            {options.map((option) => {
              const isSelected = findSelectedValue?.value === option.value;
              const isDisabled = disabledOptions.some((item) => item?.value === option.value);

              const onClick = () => {
                onToggle();
                !isDisabled && onSelect(option, isDisabled);
              };

              return (
                <li
                  key={option.value}
                  className={`item-content ${isSelected ? 'selected' : ''} ${isDisabled ? 'disabled' : 'enabled'}`}
                  onClick={onClick}
                >
                  {!!option.icon && option.icon}
                  {option.value}
                </li>
              );
            })}

            {customOption && <li className="item-content item-content-custom">{customOption}</li>}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Dropdown;
